<template>
    <div class="animated fadeIn">
        <div v-if="!editMode && !addMode" class="viewMode">
            <b-row>
                <b-col cols="12">
                    <h1>Trade Customer Management</h1>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-card>
                        <div slot="header">
                            <strong>Customer List</strong>
                        </div>
                        <b-row>
                            <b-col sm="4">
                                <b-form-group>
                                    <label for="company">Company</label>
                                    <b-form-select id="company" v-if="companiesLoaded"  v-model="filterParams.company_id"
                                        :plain="true"
                                        :options="companies"
                                        :disabled="!isMinimumSuperAdmin">
                                    </b-form-select>
                                    <div v-if="!companiesLoaded" >
                                        <i class="fa fa-spin fa-spinner"></i>
                                    </div>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group>
                                    <label for="area">Area</label>
                                    <b-form-select id="area" v-if="areasLoaded"  v-model="filterParams.area_id"
                                        :plain="true"
                                        :options="areas"
                                        :disabled="!isMinimumCompanyUser">
                                    </b-form-select>
                                    <div v-if="!areasLoaded" >
                                    <i class="fa fa-spin fa-spinner"></i> Waiting for company selection
                                    </div>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group>
                                    <label for="site">Site</label>
                                    <b-form-select id="site" v-if="sitesLoaded"  v-model="filterParams.site_id"
                                        :plain="true"
                                        :options="sites"
                                        :disabled="!isMinimumAreaUser">
                                    </b-form-select>
                                    <div v-if="!sitesLoaded" >
                                    <i class="fa fa-spin fa-spinner"></i> Waiting for area selection
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="4">
                                <b-form-group>
                                    <label for="showDeletedCustomers">Show Deleted Only</label><br/>
                                    <c-switch class="mx-1" id="showDeletedCustomers" name="showDeletedCustomers" color="primary"
                                            v-model="showDeletedCustomers" label value="1" uncheckedValue="0" dataOn="yes" dataOff="no"/>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <div v-if="!customersLoaded" class="form-container">
                            <LoadingSpinner />
                        </div>
                        <div v-if="customersLoaded" class="form-container">
                            <b-row>
                                <b-col cols="12" sm="12" md="6">
                                    <p>
                                        <b-button v-on:click="enterAddMode" variant="primary">
                                            <i class="fa fa-plus"></i>&nbsp;Add Customer
                                        </b-button>
                                    </p>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col v-for="item in customerItems" cols="12" sm="12" md="6" v-bind:key="item.id">
                                    <b-card :no-body="true" footer-class="px-3 py-2">
                                        <b-card-body class="p-3 clearfix">
                                            <i class="fa fa-bank p-3 font-2xl mr-3 float-left"></i>
                                            <div class="h5 text-warning mb-0">{{item.supplier_name}}</div>
                                            <div class="text-muted text-uppercase font-weight-bold font-xs">{{item.company_name}}</div>
                                            <!-- <div class="text-muted text-uppercase font-weight-bold font-xs">Status: <span :class="getActiveStatusForeColourClass(item.status.status_name)">{{item.status.status_name}}</span></div> -->
                                        </b-card-body>
                                        <div slot="footer">
                                            <b-link class="font-weight-bold font-xs btn-block text-muted" @click="viewCustomer(item)">View More <i class="fa fa-angle-right float-right font-lg"></i></b-link>
                                        </div>
                                    </b-card>
                                </b-col>
                            </b-row>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </div>
        <div v-if="editMode || addMode" class="editMode">
            <b-row>
                <b-col cols="12">
                    <b-button v-on:click="exitEditMode" variant="secondary">
                        <i class="fa fa-arrow-circle-left"></i>&nbsp;Back
                    </b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <h1 v-if="editMode">Edit Trade Customer</h1>
                    <h1 v-if="addMode">Add Trade Customer</h1>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-card v-if="addMode">
                        <div slot="header">
                            <strong>For which site?</strong>
                        </div>
                        <div class="form-container">
                            <b-row>
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="area">Company<span class="mandatory">*</span></label>
                                        <b-form-select id="company" v-if="companiesLoaded"  v-model="newCustomer.company_id"
                                            :plain="true"
                                            :options="companies">
                                        </b-form-select>
                                        <div v-if="!companiesLoaded" >
                                            <i class="fa fa-spin fa-spinner"></i>
                                        </div>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="area">Area<span class="mandatory">*</span></label>
                                        <b-form-select id="area" v-if="areasLoaded"  v-model="newCustomer.area_id"
                                            :plain="true"
                                            :options="areas">
                                        </b-form-select>
                                        <div v-if="!areasLoaded" >
                                            <i class="fa fa-spin fa-spinner"></i>
                                        </div>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="site">Site<span class="mandatory">*</span></label>
                                        <b-form-select id="site" v-if="sitesLoaded"  v-model="newCustomer.site_id"
                                            :plain="true"
                                            :options="sites">
                                        </b-form-select>
                                        <div v-if="!sitesLoaded" >
                                            <i class="fa fa-spin fa-spinner"></i>
                                        </div>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </div>
                    </b-card>
                    <b-card>
                        <div slot="header">
                            <strong>Customer Details</strong>
                        </div>
                        <div class="form-container">
                            <b-row>
                                <b-col sm="3">
                                    <b-form-group>
                                        <label for="supplierName">Company Name<span class="mandatory">*</span></label>
                                        <b-form-input v-model="newCustomer.supplier_name" type="text" id="supplierName"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="3">
                                    <b-form-group>
                                        <label for="supplierCode">Customer Code</label>
                                        <b-form-input v-model="newCustomer.supplier_code" type="text" id="supplierCode"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="3">
                                    <b-form-group>
                                        <label for="dvlaLicenceCode">DVLA Licence Code<span class="mandatory">*</span></label>
                                        <b-form-input v-model="newCustomer.dvla_lic_code" type="text" id="dvlaLicenceCode"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="3">
                                    <b-form-group>
                                        <label for="dvlaConfirmed">DVLA Code Confirmed</label><br/>
                                        <c-switch class="mx-1" id="dvlaConfirmed"  name="dvlaConfirmed" color="primary" v-model="newCustomer.dvla_confirmed" label value="1" uncheckedValue="0" dataOn="yes" dataOff="no" />
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="3">
                                    <b-form-group>
                                        <label for="addressPropertyNumber">Property No<span class="mandatory">*</span></label>
                                        <b-form-input v-model="newAddress.property_number" type="text" id="addressPropertyNumber"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="3">
                                    <b-form-group>
                                        <label for="addressPostCode">Post Code<span class="mandatory">*</span></label>
                                        <b-form-input v-model="newAddress.post_code" type="text" id="addressPostCode"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="3">
                                    <b-form-group>
                                        <label for="addressAddress1">Address</label>
                                        <b-form-input v-model="newAddress.address1" type="text" id="addressAddress1"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="3">
                                    <b-form-group>
                                        <label for="addressTown">Town</label>
                                        <b-form-input v-model="newAddress.town" type="text" id="addressTown"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="3">
                                    <b-form-group>
                                        <label for="addressCounty">County</label>
                                        <b-form-select id="addressCounty" v-if="countiesLoaded"  v-model="newAddress.county_id"
                                            :plain="true"
                                            :options="counties">
                                        </b-form-select>
                                        <div v-if="!countiesLoaded" >
                                            <i class="fa fa-spin fa-spinner"></i>
                                        </div>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="3">
                                    <b-form-group>
                                        <label for="addressCountry">Country</label>
                                        <b-form-select id="addressCountry" v-if="countriesLoaded"  v-model="newAddress.country_id"
                                            :plain="true"
                                            :options="countries">
                                        </b-form-select>
                                        <div v-if="!countriesLoaded" >
                                            <i class="fa fa-spin fa-spinner"></i>
                                        </div>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </div>
                    </b-card>
                    <b-card>
                        <div slot="header">
                            <strong>Contact Details</strong>
                        </div>
                        <div class="form-container">
                            <b-row>
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="contactTitle">Title</label>
                                        <b-form-select id="contactTitle" v-if="contactTitlesLoaded"  v-model="newContact.title_id"
                                            :plain="true"
                                            :options="contactTitles">
                                        </b-form-select>
                                        <div v-if="!contactTitlesLoaded" >
                                            <i class="fa fa-spin fa-spinner"></i>
                                        </div>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="contactFirstName">First Name<span class="mandatory">*</span></label>
                                        <b-form-input v-model="newContact.first_name" type="text" id="contactFirstName"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="contactLastName">Last Name<span class="mandatory">*</span></label>
                                        <b-form-input v-model="newContact.last_name" type="text" id="contactLastName"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="contactEmail">Email</label>
                                        <b-form-input v-model="newContact.email" type="text" id="contactEmail"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="contactPhone">Phone No</label>
                                        <b-form-input v-model="newContact.phone_number" type="text" id="contactPhone"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="website">Website</label>
                                        <b-form-input v-model="newCustomer.website" type="text" id="website"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="contactOptMarketing">Marketing Participation</label><br/>
                                        <c-switch class="mx-1" id="contactOptMarketing"  name="contactOptMarketing" color="primary" v-model="newContact.opt_in_marketing" label value="1" uncheckedValue="0" dataOn="yes" dataOff="no" />
                                    </b-form-group>
                                </b-col>
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="contactOptResearch">Marketing Research</label><br/>
                                        <c-switch class="mx-1" id="contactOptResearch"  name="contactOptResearch" color="primary" v-model="newContact.opt_in_research" label value="1" uncheckedValue="0" dataOn="yes" dataOff="no" />
                                    </b-form-group>
                                </b-col>
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="contactOptAnon">Anonymous Statistics</label><br/>
                                        <c-switch class="mx-1" id="contactOptAnon"  name="contactOptAnon" color="primary" v-model="newContact.opt_in_anonymously" label value="1" uncheckedValue="0" dataOn="yes" dataOff="no" />
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <hr />
                            <b-row>
                                <b-col cols="12" sm="12" md="12">
                                    <p>
                                        <b-button v-if="!newCustomer.deleted_at" v-on:click="save" variant="primary" :disabled="!allowSave">
                                            <i class="fa fa-check"></i>&nbsp;Save Customer
                                        </b-button>
                                        <b-button class="ml-1" v-if="!newCustomer.deleted_at && isUserSuperAdmin" v-on:click="deleteCustomer" variant="danger">
                                            <i class="fa fa-trash"></i>&nbsp;Delete Customer
                                        </b-button>
                                        <b-button class="float-right" v-if="newCustomer.deleted_at" v-on:click="undeleteSupplier" variant="warning" :disabled="!allowSave">
                                            <i class="fa fa-undo"></i>&nbsp;Undelete Customer
                                        </b-button>&nbsp;
                                    </p>
                                    <b-alert v-if="saveSuccess" variant="success" show><strong>Data saved successfully.</strong></b-alert>
                                    <b-alert v-if="saveError" variant="danger" show><strong>Error saving data. Please try again.</strong></b-alert>
                                    <b-alert v-if="saveInProgress" variant="info" show><strong>Saving data. Please wait...</strong></b-alert>
                                </b-col>
                            </b-row>
                        </div>
                    </b-card>
                    <b-card v-if="editMode">
                        <div slot="header">
                            <strong>Linked Templates</strong>
                        </div>
                        <div class="form-container">
                            <b-row v-if="templatesLoaded">
                                <b-col sm="3">
                                    <b-form-group>
                                        <label for="tableFilter">Filter</label>
                                        <b-form-input v-model="tableFilter" type="text" id="tableFilter"></b-form-input>
                                    </b-form-group>                                    
                                </b-col>                             
                            </b-row>
                            <div v-if="templatesLoading" class="form-container">
                                <LoadingSpinner />
                            </div>
                            <div v-if="templatesLoaded" class="form-container">
                                <b-row>
                                    <b-col cols="12">
                                        <div id="customer-list">
                                            <!--<c-table :filter="tableFilter" :table-data="contactItems" :fields="tableFields" :perPage="10" hover bordered caption="All templates"></c-table>-->
                                            <b-table
                                                id="templates-table"
                                                class="datalist-table" 
                                                bordered
                                                select-mode="single"                                            
                                                :items="templateItems" 
                                                :fields="tableFields"
                                                :filter="tableFilter"
                                                :current-page="tableCurrentPage"
                                                :per-page="tablePerPage"
                                                responsive="sm"
                                                >
                                            </b-table>
                                        </div>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="6" class="my-1">
                                        <b-pagination
                                        v-model="tableCurrentPage"
                                        :total-rows="tableTotalRows"
                                        :per-page="tablePerPage"
                                        class="my-0"
                                        ></b-pagination>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>

import LoadingSpinner from '../../components/loadingSpinner/LoadingSpinner';
import { Switch as cSwitch } from '@coreui/vue';
import cTable from '../../components/table/Table';

const getHTTPHeaders = () => {
    let userObj = JSON.parse(localStorage.getItem('user'));
    let headerConfig = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': 'Bearer ' + userObj.token,
        }
    }
    return headerConfig;
}

const getCurrentUser = () => {
    return new Promise((resolve, reject) => {
        let user = JSON.parse(localStorage.getItem('user'));
        if (user != null) {
            resolve(user);
        }
        else {
            reject();
        }

    });
}

const getSuppliersList = (($http, userFilter) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        $http.get(`suppliers-with-deleted?company_id=${userFilter.company_id}&area_id=${userFilter.area_id}&site_id=${userFilter.site_id}`, headersObj)
            .then((response) => {
                let suppliers = response.data.suppliers;
                resolve(suppliers);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const getCompaniesList = (($http) => {
  return new Promise((resolve, reject) => {
    let headersObj = getHTTPHeaders();
      $http.get('getCompaniesForSelect', headersObj)
        .then((response) => {
          resolve(response.data.companies);
        })
        .catch ((err) => {
          console.error(err);
          reject(err);
        });
  });
});

const getSiteList = (($http, areaId) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        $http.get('getSitesForSelect?area_id=' + areaId, headersObj)
            .then((response) => {
                resolve(response.data.sites);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const getAreaList = (($http, companyId) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
         $http.get('getAreasForSelect?company_id=' + companyId, headersObj)
            .then((response) => {
                resolve(response.data.areas);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const getContactTitles = (($http) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        $http.get("getContactTitlesForSelect", headersObj)
            .then((response) => {
                resolve(response.data.titles);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const getAddressCounties = (($http) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        $http.get("getCountiesForSelect", headersObj)
            .then((response) => {
                resolve(response.data.counties);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const getAddressCountries = (($http) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        $http.get("getCountriesForSelect", headersObj)
            .then((response) => {
                resolve(response.data.countries);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const getTemplates = (($http, filterObj) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        $http.get(`templates?company_id=${filterObj.company_id}&area_id=${filterObj.area_id}&site_id=${filterObj.site_id}&is_deleted=${filterObj.is_deleted}`, headersObj)
            .then((response) => {
                resolve(response.data.templates);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});


export default {
  name: 'suppliers',
  components: {
      LoadingSpinner: LoadingSpinner,
      cSwitch,
      cTable
  },
  data () {
    return {
        newCustomer: {
            supplier_name: "",
            short_name: "",
            company_name: "",
            company_id: 0,
            area_id: 0,
            site_id: -1,
            website: "",
            status_id: 1,
            dvla_lic_code: "",
            dvla_confirmed: 0,
            dvla_confirmed_date: Date.now(),
            dvla_confirmed_by: 0,
            supplier_code: "",
            is_active: "1",
            contactDetails: {},
            addressDetails: {},
            contact: {},
            address: {}
        },
        editMode: false,
        addMode: false,
        allowSave: true,
        saveError: false,
        saveInProgress: false,
        saveSuccess: false,
        userObj: {},
        wizardGetContactInfo: false,
        wizardGetAddressInfo: false,
        // Customer Information
        companies: [],
        areas: [],
        sites: [],
        statuses: [],
        suppliers: [],
        customersLoaded: false,
        areasLoaded: false,
        statusesLoaded: false,
        sitesLoaded: false,
        allowDetailsContinue: false,
        tableFilter: '',
        tablePerPage: 20,
        tableCurrentPage: 1,
        tableTotalRows: 0,
        tableFields: [
            {key: 'supplier_name', label: 'Customer', sortable: true},
            {key: 'dvla_lic_code', label: 'DVLA Licence Code', sortable: true},
            {key: 'company_name', label: 'Company', sortable: true},
            {key: 'branch.branch_name', label: 'Area', sortable: true},
            {key: 'site.site_name', label: 'Site', sortable: true},
            {key: 'status.status_name', label: 'Status', sortable: true}
        ],
        customerItems: [],
        seedCustomerItems: [],
        // Contact Information
        newContact: {
            first_name: "",
            last_name: "",
            title_id: 0,
            phone_number: "",
            mobile_number: "",
            email: "",
            company_name: "",
            contact_type_id: 0,
            contact_category_id: 0,
            contact_method_id: 0,
            contact_role_id: 0,
            opt_in_marketing: 0,
            opt_in_research: 0,
            opt_in_anonymously: 0,
            group_id: 0,
            area_id: 0,
            site_id: 0,
            is_active: 1
        },
        contactCategories: [],
        contactTypes: [],
        contactMethods: [],
        contactRoles: [],
        contactTitles: [],
        contactCategoriesLoaded: false,
        contactTypesLoaded: false,
        contactMethodsLoaded: false,
        contactRolesLoaded: false,
        contactTitlesLoaded: false,
        allowContactsContinue: false,
        // Address Information
        newAddress: {
            is_default: 1,
            property_number: "",
            address1: "",
            address2: "",
            address3: "",
            address4: "",
            street: "",
            town: "",
            post_code: "",
            delivery_notes: "",
            county_id: 0,
            country_id: 0,
            company_id: 0,
            group_id: 0,
            area_id: 0,
            site_id: 0,
            address_category_id: 0,
            address_type_id: 0,
            telephone_number: "",
            is_invoice_address: 1,
            is_default_delivery_address: 1,
            is_active: 1
        },
        countries: [],
        counties: [],
        addressCategories: [],
        addressTypes: [],
        companiesLoaded: false,
        countriesLoaded: false,
        countiesLoaded: false,
        addressCategoriesLoaded: false,
        addressTypesLoaded: false,
        filterParams: {
            company_id: -1,
            area_id: -1,
            site_id: -1,
        },
        userAuthLevel : '',
        isAfterCreated: false,
        templatesLoaded: false,
        templatesLoading: false,
        templateItems: [],
        tableFilter: '',
        tablePerPage: 20,
        tableCurrentPage: 1,
        tableTotalRows: 0,
        tableFields: [
            {key: 'template_name', label: 'Template Name', sortable: true},
            {key: 'area_name', label: 'Branch Name', sortable: true},
            {key: 'plate_size', label: 'Plate Size', sortable: true},
            {key: 'slogan', label: 'Slogan', sortable: true},
            {key: 'postcode', label: 'Post Code', sortable: true},
            {key: 'is_default_text', label: 'Is Default', sortable: true}
        ],
        showDeletedCustomers: 0,
    }
  },
  created () {
    getCurrentUser(this.$http)
        .then(async (userDetails) => {
            this.$data.isAfterCreated = false;
            this.$data.filterParams.company_id = userDetails.company_id;
            this.$data.filterParams.area_id = userDetails.area_id;
            this.$data.filterParams.site_id = userDetails.site_id;
            this.$data.userAuthLevel = userDetails.auth;
            
            this.getInitialData();
            await this.getCustomers();
            this.$data.isAfterCreated = true;
        })
  },
  watch: {
    'newCustomer.company_id': function(val, oldVal) {
    
        // get the branches for the selected company
        // clear it out first
        this.$data.areas = [];
        getAreaList(this.$http, val)
            .then((areaList) => {
                if (this.$data.userAuthLevel == 'Super Admin' || this.$data.userAuthLevel == 'Company Users') {
                    this.$data.areas.push({value:0, text: 'Select Area'});
                    this.$data.newCustomer.area_id = 0;
                    this.$data.newCustomer.site_id = 0;
                }
                areaList.map((item) => {
                    this.$data.areas.push(item);
                });
                this.$data.areasLoaded = true;
                
            })
            .catch ((err) => {
                console.error(err);
            }); 
    },
      // Customer details
      'newCustomer.area_id': function(val, oldVal) {
        // get the sites for the selected branch
        //console.log('Go get the list');
        this.$data.sites = [];
        getSiteList(this.$http, val)
            .then((siteList) => {
                this.$data.sites.push({value:0, text: 'Select Site'});
                this.$data.newCustomer.site_id = 0;

                siteList.map((item) => {
                    this.$data.sites.push(item);
                });
                this.$data.sitesLoaded = true;               
            })
            .catch ((err) => {
                console.error(err);
            });
      },
      'newCustomer.site_id': function(val, oldVal) {
        this.checkAllowSave();
      },
      'newCustomer.supplier_name': function(val, oldVal) {
        this.checkAllowSave();
      },
      'newCustomer.dvla_lic_code': function(val, oldVal) {
        this.checkAllowSave();
      },
      'newAddress.property_number': function(val, oldVal) {
        this.checkAllowSave();
      },
      'newAddress.post_code': function(val, oldVal) {
        this.checkAllowSave();
      },
      // Contact information
      'newContact.first_name': function(val, oldVal) {
        this.checkAllowSave();
      },
      'newContact.last_name': function(val, oldVal) {
        this.checkAllowSave();
      },
      'newCustomer.dvla_confirmed': function(val, oldVal) {
        this.checkAllowSave();
      },
    'filterParams.company_id': function(val, oldVal) {
    
        // get the branches for the selected company
        // clear it out first
        this.$data.areas = [];
        getAreaList(this.$http, val)
            .then((areaList) => {
                if (this.$data.userAuthLevel == 'Super Admin' || this.$data.userAuthLevel == 'Company Users') {
                    this.$data.areas.push({value:0, text: 'All Areas'});
                    this.$data.filterParams.area_id = 0;
                    this.$data.filterParams.site_id = 0;
                }
                areaList.map((item) => {
                    this.$data.areas.push(item);
                });
                this.$data.areasLoaded = true;
                //this.$data.filterParams.company_id = val;
                const userFilter = {
                    company_id: this.$data.filterParams.company_id,
                    area_id: this.$data.filterParams.area_id,
                    site_id: this.$data.filterParams.site_id
                };
                
                if (oldVal != -1) {
                    this.getCustomers();
                }
            })
            .catch ((err) => {
                console.error(err);
            }); 
    },
    'filterParams.area_id': function(val, oldVal) {

        // clear it out first
        this.$data.sites = [];
        this.$data.sites.push({value:0, text: 'All Sites'});
        this.$data.filterParams.site_id = 0;
        this.$data.sitesLoaded = true;

        console.log(this.$data.isAfterCreated);

        if (parseInt(val) == 0) {
            this.filterCustomers();
            return;
        }

        if (parseInt(val) > 0 && this.$data.isAfterCreated) {
            getSiteList(this.$http, val)
                .then((sitesList) => {
                    // if (this.$data.userAuthLevel == 'Super Admin' || this.$data.userAuthLevel == 'Company Users') {
                    //     this.$data.sites.push({value:0, text: 'All Sites'});
                    //     this.$data.filterParams.site_id = 0;
                    // }
                    sitesList.map((item) => {
                        this.$data.sites.push(item);
                    });
                    this.$data.sitesLoaded = true;
                    this.filterCustomers();
                })
                .catch ((err) => {
                    console.error(err);
                });
        }
    },
    'filterParams.site_id': function(val, oldVal) {

        if (oldVal == -1)
        {
            return;
        }
        this.filterCustomers();
        
    },
    'showDeletedCustomers': function(val) {
        this.filterCustomers();
    }

  },
  computed: {
    isUserSuperAdmin() {
        if (this.$data.userAuthLevel == 'Super Admin') {
            return true;
        }
        else {
            return false;
        }
    },
    isMinimumSuperAdmin() {
      let returnVal = false;
      switch (this.$data.userAuthLevel) {
        case 'Super Admin':
        case 'Read Only':
          returnVal = true;
          break;
        default:
          returnVal = false;
      }
      
      return returnVal;
    },
    isMinimumCompanyUser() {
      let returnVal = false;
      //console.log('Company: ', this.$data.userAuthLevel);
      switch (this.$data.userAuthLevel) {
        case 'Super Admin':
        case 'Company Users':
        case 'Read Only':
          returnVal = true;
          break;
        default:
          returnVal = false;
      }
      //console.log('Company: ', returnVal);
      return returnVal;
    },
    isMinimumAreaUser() {
      let returnVal = false;
      //console.log('Area: ', this.$data.userAuthLevel);
      switch (this.$data.userAuthLevel) {
        case 'Super Admin':
        case 'Company Users':
        case 'Area Users':
        case 'Read Only':
          returnVal = true;
          break;
        default:
          returnVal = false;
      }
      //console.log('Area: ', returnVal);
      return returnVal;
    },
    isMinimumSiteUser() {
      let returnVal = false;
      //console.log('Site: ', this.$data.userAuthLevel);
      switch (this.$data.userAuthLevel) {
        case 'Super Admin':
        case 'Company Users':
        case 'Area Users':
        case 'Site Users':
        case 'Read Only':
          returnVal = true;
          break;
        default:
          returnVal = false;
      }
      
      return returnVal;
    }
  },
  methods : {
    checkAllowSave() {
        if (this.addMode) {
            if (this.$data.newCustomer.site_id < 1) {
                this.$data.allowSave = false;
                return;
            }
        }
        if (this.$data.newCustomer.supplier_name.length < 1) {
            this.$data.allowSave = false;
            return;
        }
        if (this.$data.newCustomer.dvla_lic_code.length < 1) {
            this.$data.allowSave = false;
            return;
        }
        if (this.$data.newAddress.property_number.length < 1) {
            this.$data.allowSave = false;
            return;
        }
        if (this.$data.newAddress.post_code.length < 1) {
            this.$data.allowSave = false;
            return;
        }
        if (this.$data.newContact.first_name.length < 1) {
            this.$data.allowSave = false;
            return;
        }
        if (this.$data.newContact.last_name.length < 1) {
            this.$data.allowSave = false;
            return;
        }
        if (this.$data.newCustomer.dvla_confirmed == 0) {
            this.$data.allowSave = false;
            return;
        }
        this.$data.allowSave = true;
    },
    getInitialData() {
      getCompaniesList(this.$http)
        .then((results) => {
            if (this.$data.userAuthLevel == 'Super Admin') {
                this.$data.companies.push({value:0, text: 'Select Company'});
            }
            results.map((item) => {
                this.$data.companies.push(item);
            });            
            this.$data.companiesLoaded = true;
        });
    },
    getActiveStatusForeColourClass(statusName) {
        return statusName.toLowerCase() == "active" ? 'trade-active' : 'trade-disabled';
    },
    viewCustomer(item) {
        
        const customer = item;
        console.log(item);

        this.$data.editMode = true;
        this.enterEditMode();
        this.$data.newCustomer = customer;
        this.$data.newAddress = customer.address;
       
        if(this.$data.newCustomer.dvla_confirmed) this.$data.newCustomer.dvla_confirmed="1"; // vue is having issues with integers / strings here

        this.$data.newContact.id = this.$data.newCustomer.contact.id;
        this.$data.newContact.first_name = this.$data.newCustomer.contact.first_name;
        this.$data.newContact.last_name = this.$data.newCustomer.contact.last_name;
        this.$data.newContact.title_id = this.$data.newCustomer.contact.title_id;
        this.$data.newContact.email = this.$data.newCustomer.contact.email;
        this.$data.newContact.phone_number = this.$data.newCustomer.contact.phone_number;
        this.$data.newContact.opt_in_marketing = (this.$data.newCustomer.contact.opt_in_marketing ? "1" : "0");
        this.$data.newContact.opt_in_research = (this.$data.newCustomer.contact.opt_in_research ? "1" : "0");
        this.$data.newContact.opt_in_anonymously = (this.$data.newCustomer.contact.opt_in_anonymously ? "1" : "0");

        this.checkAllowSave();

        this.getTemplates(item);
    },
    getTemplates(item) {
        this.$data.templatesLoaded = false;
        this.$data.templatesLoading = true;
        const userFilter = {
            company_id: item.company_id,
            area_id: item.area_id,
            site_id: item.site_id,
            is_deleted: 0
        };
        getTemplates(this.$http, userFilter)
            .then((templatetList) => {
                this.$data.tableTotalRows = templatetList.length;
                this.$data.templateItems = templatetList
                    .filter(templateItem => templateItem.supplier_id == item.id)
                    .map((templateItem) => {
                        console.log(templateItem.supplier_id + ' = ' + item.id);
                        
                        templateItem.plate_size = templateItem.plate_width + "x" + templateItem.plate_height;
                        templateItem.area_name = templateItem.area.area_name;
                        if(templateItem.is_default) templateItem.is_default="1";
                        if (templateItem.slogan == null) {
                            templateItem.slogan = '';
                        }
                    
                        templateItem.is_default_text = templateItem.is_default == 0 ? 'No' : 'Yes';
                        return templateItem;
                        
                    });
                //this.$data.seedTemplateItems = JSON.parse(JSON.stringify(this.$data.templateItems));
                this.$data.templatesLoading = false;
                this.$data.templatesLoaded = true;
            })
            .catch ((err) => {
                console.error(err);
            });
    },
    getHTTPHeaders() {
      let user = JSON.parse(localStorage.getItem("user"));
      return {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          'Authorization': 'Bearer ' + user.token,
        }
      };
    },
    getCustomers() {
        return new Promise(async (resolve, reject) => {
            const userFilter = {
                company_id: this.$data.filterParams.company_id,
                area_id: this.$data.filterParams.area_id,
                site_id: this.$data.filterParams.site_id,
                is_deleted: this.$data.showDeletedCustomers,
                auth_level: this.$data.userAuthLevel
            };
            const response = await getSuppliersList(this.$http, userFilter);
                
            if(typeof response === 'undefined') {
                this.$data.customersLoaded = false;
                throw Error('Cannot load suppliers');
                reject();
            }
            
            this.$data.customerItems = response;
            this.$data.customersLoaded = true;
            this.$data.seedCustomerItems = JSON.parse(JSON.stringify(this.$data.customerItems));
            this.$data.customerItems = this.$data.customerItems.filter((item) => {
                let returnVal = false;
                // check if we want deleted or not
                if (userFilter.is_deleted == 1) {
                    if (item.deleted_at != null) {
                        returnVal = true;
                    }
                    else {
                        returnVal = false;
                    }
                }
                else {
                    if (item.deleted_at == null) {
                        returnVal = true;
                    }
                    else {
                        returnVal = false;
                    }
                }

                return returnVal;
            });
            resolve();
        });
    },
    filterCustomers() {
        const userFilter = {
            company_id: this.$data.filterParams.company_id,
            area_id: this.$data.filterParams.area_id,
            site_id: this.$data.filterParams.site_id,
            is_deleted: this.$data.showDeletedCustomers
        };
        this.$data.customerItems = this.$data.seedCustomerItems.filter((item) => {
            // //console.log(item.company_id, userFilter.company_id);
            let returnVal = false;
            if (item.company_id == userFilter.company_id) {
                returnVal = true;
                if (userFilter.area_id == 0) {
                    returnVal = true;
                } else {
                    if (item.area_id == userFilter.area_id) {
                        if (userFilter.site_id == 0) {
                            returnVal = true;
                        }
                        else {
                            if (item.site_id == userFilter.site_id) {
                                returnVal = true;
                            }
                            else {
                                returnVal = false;
                            }
                        }
                    }
                    else {
                        returnVal = false;
                    }
                }
            }
            
            // if it's already been filtered out, we don't care about it
            // so only deal with true ones!
            if (returnVal) {
                // check if we want deleted or not
                if (userFilter.is_deleted == 1) {
                    if (item.deleted_at != null) {
                        returnVal = true;
                    }
                    else {
                        returnVal = false;
                    }
                }
                else {
                    if (item.deleted_at == null) {
                        returnVal = true;
                    }
                    else {
                        returnVal = false;
                    }
                }
            }

            return returnVal;
        });
    },
    exitEditMode() {
        // this.getInitialData();
        this.$data.editMode = false;
        this.$data.addMode = false;
        this.$data.countriesLoaded = false;
        this.$data.countiesLoaded = false;
        this.$data.addressCategoriesLoaded = false;
        this.$data.addressTypesLoaded = false;
        this.$data.statusesLoaded = false;
        //this.$data.sitesLoaded = false;
        //this.$data.areasLoaded = false;
        this.$data.contactCategoriesLoaded = false;
        this.$data.contactTypesLoaded = false;
        this.$data.contactMethodsLoaded = false;
        this.$data.contactRolesLoaded = false;
        this.$data.contactTitlesLoaded = false;

        this.$data.wizardGetAddressInfo = false;
        this.$data.wizardGetContactInfo = false;

        this.$data.saveInProgress = false;
        this.$data.saveSuccess = false;
        this.$data.saveError = false;

    },
    enterEditMode() {
        this.$data.saveInProgress = false;
        this.$data.saveSuccess = false;
        this.$data.saveError = false;
        this.$data.editMode = true;
        this.$data.allowSave = false;
        // get user and lookup data
        getCurrentUser()
            .then((userDetails) => {
                //console.log(userDetails);
                this.$data.userObj = userDetails;
                return getAddressCounties(this.$http);
            })
            .then((countiesList) => {
                this.$data.counties = countiesList;
                this.$data.countiesLoaded = true;
                return getAddressCountries(this.$http);
            })
            .then((countriesList) => {
                this.$data.countries = countriesList;
                this.$data.countriesLoaded = true;
                return getContactTitles(this.$http);
            })
            .then((titlesList) => {
                this.$data.contactTitles = titlesList;
                // console.log(this.$data.contactTitles = titlesList);
                this.$data.contactTitlesLoaded = true;
            })
            .catch ((err) => {
                console.error(err);
            });
    },
    clearAlerts() {
        this.$data.saveError = false;
        this.$data.saveInProgress = false;
    },
    save(){
        this.$data.saveError = false;
        this.$data.saveInProgress = true;
        if (this.$data.editMode) {
            this.updateSupplier(0)
                .then(() => {
                    return this.updateContact();
                })
                .then(() => {
                    return this.updateAddress();
                })
                .then((response) => {
                    if(response.data.success === true) {
                        this.$data.saveInProgress = false;
                        this.$data.saveSuccess = true;
                        setTimeout(() => {
                            this.getCustomers();
                            this.exitEditMode();
                        }, 1000);
                    }
                    else {
                        this.$data.saveInProgress = false;
                        this.$data.saveSuccess = false;
                        this.$data.saveError = true;
                    }
                })
                .catch ((err) => {
                    console.error(err);
                    this.$data.saveInProgress = false;
                    this.$data.saveSuccess = false;
                    this.$data.saveError = true;
                });
        }
        if (this.$data.addMode) {
            // we need to get the selected company name
            const selectedCompanyName = this.$data.companies.filter(c => c.value == this.$data.newCustomer.company_id);

            console.log(selectedCompanyName);

            let dataPostObject = {
                supplier: {
                    supplier_name: this.$data.newCustomer.supplier_name,
                    short_name: this.$data.newCustomer.short_name,
                    company_name: selectedCompanyName[0].text,
                    company_id: this.$data.newCustomer.company_id,
                    area_id: this.$data.newCustomer.area_id,
                    site_id: this.$data.newCustomer.site_id,
                    website: this.$data.newCustomer.website,
                    status_id: this.$data.newCustomer.status_id,
                    dvla_lic_code: this.$data.newCustomer.dvla_lic_code,
                    dvla_confirmed: this.$data.newCustomer.dvla_confirmed,
                    supplier_code: this.$data.newCustomer.supplier_code
                },
                address: {
                    is_default_delivery_address: this.$data.newAddress.is_default_delivery_address,
                    property_number: this.$data.newAddress.property_number,
                    address1: this.$data.newAddress.address1,
                    address2: this.$data.newAddress.address2,
                    address3: this.$data.newAddress.address3,
                    address4: this.$data.newAddress.address4,
                    street: this.$data.newAddress.street,
                    town: this.$data.newAddress.town,
                    post_code: this.$data.newAddress.post_code,
                    county_id: this.$data.newAddress.county_id,
                    country_id: this.$data.newAddress.country_id,
                    company_id: this.$data.newAddress.company_id,
                    group_id: this.$data.newAddress.group_id,
                    area_id: this.$data.newCustomer.area_id,
                    site_id: this.$data.newCustomer.site_id,
                    telephone_number: this.$data.newAddress.telephone_number,
                    is_invoice_address: this.$data.newAddress.is_invoice_address,
                    address_category_id: this.$data.newAddress.address_category_id,
                    address_type_id: this.$data.newAddress.address_type_id
                },
                contact: {
                    first_name: this.$data.newContact.first_name,
                    last_name: this.$data.newContact.last_name,
                    title_id: this.$data.newContact.title_id,
                    phone_number: this.$data.newContact.phone_number,
                    mobile_number: this.$data.newContact.mobile_number,
                    email: this.$data.newContact.email,
                    company_name: this.$data.newCustomer.company_name,
                    contact_type_id: this.$data.newContact.contact_type_id,
                    contact_category_id: this.$data.newContact.contact_category_id,
                    contact_method_id: this.$data.newContact.contact_method_id,
                    contact_role_id:this.$data.newContact.contact_role_id,
                    opt_in_marketing: this.$data.newContact.opt_in_marketing,
                    opt_in_research: this.$data.newContact.opt_in_research,
                    opt_in_anonymously: this.$data.newContact.opt_in_anonymously,
                    group_id: this.$data.newContact.group_id,
                    area_id: this.$data.newCustomer.area_id,
                    site_id: this.$data.newCustomer.site_id,
                    is_active: true
                }
            }

            const headersObj = getHTTPHeaders();
            // save the customer
            this.$http.post('supplier/bulk', {
                supplier: dataPostObject.supplier,
                address: dataPostObject.address,
                contact: dataPostObject.contact
            },
            headersObj)
            .then((response) => {
                if (response.data.success == true) {
                    this.$data.saveInProgress = false;
                    this.$data.saveError = false;
                    this.exitEditMode();
                }
                else {
                    // data error
                    this.$data.saveInProgress = false;
                    this.$data.saveError = true;
                }
            })
            .catch ((err) => {
                console.error(err);
                this.$data.saveInProgress = false;
                this.$data.saveError = true;
            });
        }
    },
    deleteCustomer() {
        this.$data.saveInProgress = true;
        // passing in a 1 is the value for the soft delete
        this.updateSupplier(1)
        .then((response) => {
            if(response.data.success === true) {
                this.$data.saveInProgress = false;
                this.$data.saveSuccess = true;
                setTimeout(() => {
                    this.getCustomers();
                    this.exitEditMode();
                }, 1000);
            }
        })
        .catch ((err) => {
            console.error(err);
            this.$data.saveInProgress = false;
            this.$data.saveError = true;
        });
    },
    async undeleteSupplier() {
        const headersObj = getHTTPHeaders();
        const response = await this.$http.put('supplier/undelete/'+this.$data.newCustomer.id,null,headersObj);

        if (false === response.data.success) {
            this.$data.saveError = true;
        } else {
            this.exitEditMode();
            this.getCustomers();
        }
    },
    updateContact(){
      let payload = {
            id: this.$data.newContact.id,
            first_name: this.$data.newContact.first_name,
            last_name: this.$data.newContact.last_name,
            title_id: this.$data.newContact.title_id,
            phone_number: this.$data.newContact.phone_number,
            mobile_number: this.$data.newContact.mobile_number,
            email: this.$data.newContact.email,
            company_name: this.$data.newCustomer.company_name,
            contact_type_id: this.$data.newContact.contact_type_id,
            contact_category_id: this.$data.newContact.contact_category_id,
            contact_method_id: this.$data.newContact.contact_method_id,
            contact_role_id:this.$data.newContact.contact_role_id,
            opt_in_marketing: this.$data.newContact.opt_in_marketing,
            opt_in_research: this.$data.newContact.opt_in_research,
            opt_in_anonymously: this.$data.newContact.opt_in_anonymously,
            company_id: this.$data.newCustomer.company_id,
            area_id: this.$data.newCustomer.area_id,
            site_id: this.$data.newCustomer.site_id,
        }

        let headersObj = getHTTPHeaders();
        return this.$http.put('contact/'+payload.id, payload, headersObj)
        .then((response) => {
            console.debug(response)
            return response
        })
        .catch ((err) => {
            console.error(err);
            throw new err
        });
    },
    updateSupplier(isDeleted) {
        let payload = {
            id: this.$data.newCustomer.id,
            supplier_name: this.$data.newCustomer.supplier_name,
            short_name: this.$data.newCustomer.short_name,
            area_id: this.$data.newCustomer.area_id,
            site_id: this.$data.newCustomer.site_id,
            website: this.$data.newCustomer.website,
            status_id: this.$data.newCustomer.status_id,
            dvla_lic_code: this.$data.newCustomer.dvla_lic_code,
            dvla_confirmed: this.$data.newCustomer.dvla_confirmed,
            dvla_confirmed_date: this.$data.newCustomer.dvla_confirmed_date,
            dvla_confirmed_by: this.$data.newCustomer.dvla_confirmed_by,
            supplier_code: this.$data.newCustomer.supplier_code,
            deleted: isDeleted
        }

        let headersObj = getHTTPHeaders();
        
        if (isDeleted) {
            return this.$http.delete('supplier/'+payload.id, headersObj);
        }
        else {
            return this.$http.put('supplier/'+payload.id, payload, headersObj);
        }
    },
    
    updateAddress() {
        let payload = {
            id: this.$data.newAddress.id,
            is_default: this.$data.newAddress.is_default,
            is_default_delivery_address: this.$data.newAddress.is_default_delivery_address,
            property_number: this.$data.newAddress.property_number,
            address1: this.$data.newAddress.address1,
            address2: this.$data.newAddress.address2,
            address3: this.$data.newAddress.address3,
            address4: this.$data.newAddress.address4,
            street: this.$data.newAddress.street,
            town: this.$data.newAddress.town,
            post_code: this.$data.newAddress.post_code,
            county_id: this.$data.newAddress.county_id,
            country_id: this.$data.newAddress.country_id,
            // company: this.$data.newAddress.company_id,
            company_id: this.$data.newAddress.company_id,
            area_id: this.$data.newCustomer.area_id,
            site_id: this.$data.newCustomer.site_id,
            telephone_number: this.$data.newAddress.telephone_number,
            is_invoice_address: this.$data.newAddress.is_invoice_address,
            address_category_id: this.$data.newAddress.address_category_id,
            address_type_id: this.$data.newAddress.address_type_id,
            delivery_notes: this.$data.newAddress.delivery_notes
        }

        let headersObj = getHTTPHeaders();
        return this.$http.put('address/'+payload.id, payload, headersObj)
        .then((response) => {
            console.debug(response)
            return response
        })
        .catch ((err) => {
            console.error(err)
            throw new err
        });
    },
    updateCustomer() {

        // get the company data
        let company = {};

        this.$data.groups.forEach((element) => {
            if (element.id == this.$data.groupIdToChangeActiveStatus) {
                company = element;
            }
        });

        let newActiveStatus = 0;
        if (company.is_active == 0) {
            newActiveStatus = 1;
        }

        let headersObj = getHTTPHeaders();
        this.$http.post('updateCompany', {
            id: company.id,
            company_name: company.company_name,
            company_short_name: company.company_short_name,
            main_contact_number: company.main_contact_number,
            main_email: company.main_email,
            main_address: company.main_address,
            main_post_code: company.main_post_code,
            main_town: company.main_town,
            county_id: company.county.id,
            country_id: company.country.id,
            sub_domain: company.sub_domain,
            licence_id: company.licence_id,
            is_sap: company.is_sap,
            is_active: newActiveStatus
        },
        headersObj)
        .then((response) => {
            //console.log('Done!');
            // update to re-render view
            this.getCompanyData();
        })
        .catch ((err) => {
            console.error(err);
            this.$data.activeStateModal = false;
        });
    },
    enterAddMode() {

        // clear out new customer data
        this.$data.newCustomer.supplier_name = "";
        this.$data.newCustomer.short_name = "",
        this.$data.newCustomer.company_name = "";
        this.$data.newCustomer.company_id = 0;
        this.$data.newCustomer.area_id = 0;
        this.$data.newCustomer.site_id = 0;
        this.$data.newCustomer.website = "";
        this.$data.newCustomer.status_id = 1;
        this.$data.newCustomer.dvla_lic_code = "";
        this.$data.newCustomer.dvla_confirmed = 0;
        this.$data.newCustomer.dvla_confirmed_date = Date.now();
        this.$data.newCustomer.dvla_confirmed_by = 0;
        this.$data.newCustomer.supplier_code = "";
        this.$data.newCustomer.is_active = "1";
        this.$data.newCustomer.contactDetails = {};
        this.$data.newCustomer.addressDetails = {};
        this.$data.newCustomer.contact = {};
        this.$data.newCustomer.address = {};

        this.$data.areasLoaded = false;
        this.$data.sitesLoaded = false;

        this.$data.saveInProgress = false;
        this.$data.saveSuccess = false;
        this.$data.saveError = false;
        this.$data.addMode = true;
        this.$data.allowSave = false;
        // get user and lookup data
        getCurrentUser()
            .then((userDetails) => {
                //console.log(userDetails);
                this.$data.userObj = userDetails;
                return getAddressCounties(this.$http);
            })
            .then((countiesList) => {
                this.$data.counties = countiesList;
                this.$data.countiesLoaded = true;
                return getAddressCountries(this.$http);
            })
            .then((countriesList) => {
                this.$data.countries = countriesList;
                this.$data.countriesLoaded = true;
                return getContactTitles(this.$http);
            })
            .then((titlesList) => {
                this.$data.contactTitles = titlesList;
                // console.log(this.$data.contactTitles = titlesList);
                this.$data.contactTitlesLoaded = true;
            })
            .catch ((err) => {
                console.error(err);
            });
    }
  }
}
</script>
<style scoped>
    .trade-active {
        color: #4dbd74!important;
    }
    .trade-disabled {
        color: #f86c6b!important;
    }
    .datalist-table table tr:hover {
        cursor: none;
    }
</style>
